import { render, staticRenderFns } from "./main_events.vue?vue&type=template&id=0829bcc7&"
import script from "./main_events.vue?vue&type=script&lang=js&"
export * from "./main_events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports